<template>
  <b-container>
    <div>
      <b-card title="Latest stash api" bg-variant="dark" class="text-light">
        <b-card-text class="text-light"> <b-link :href="'https://www.pathofexile.com/api/public-stash-tabs?id=' + stashID">{{stashID}}</b-link></b-card-text>
      </b-card>

      <b-card title="get endpoint" bg-variant="dark" class="text-light">
        <b-card-text class="text-light">
          <h4>Description</h4>
          <p>
            category := name from /categories league := name from /leagues
            <br />
            <kbd
              >https://api.poe.watch/get?category={category}&league={league}</kbd
            >
            <br />Example URL:
            <kbd>
              <a
                href="https://api.poe.watch/get?category=armour&league=Harvest"
                target="_blank"
                >https://api.poe.watch/get?category=armour&league=Harvest</a
              >
            </kbd>
          </p>
          <h4>Reply-Fields</h4>
          <b-table
            hover
            :items="getList"
            :fields="fields"
            striped
            dark
            :fixed="true"
          ></b-table>
        </b-card-text>
      </b-card>

      <b-card
        title="categories endpoint"
        bg-variant="dark"
        class="mt-2 text-light"
        class-title
      >
        <b-card-text class="text-light">
          <h4>Description</h4>
          Get current categories for
          <kbd>/get</kbd>
          <p>
            <kbd>https://api.poe.watch/categories</kbd>
          </p>
          <h4>Reply-Fields</h4>
          <b-table
            hover
            :items="categoriesList"
            :fields="fields"
            striped
            dark
            :fixed="true"
          ></b-table>
        </b-card-text>
      </b-card>

      <b-card
        title="history endpoint"
        bg-variant="dark"
        class="mt-2 text-light"
        class-title
      >
        <b-card-text class="text-light">
          <h4>Description</h4>
          Get the history for a certain item as an array.
          <p>
            <kbd>https://api.poe.watch/history?id={id}&league={league}</kbd>
            <br />Example URL:
            <kbd>
              <a
                href="https://api.poe.watch/history?id=470&league=Harvest"
                target="_blank"
                >https://api.poe.watch/history?id=470&league=Harvest</a
              >
            </kbd>
          </p>
          <h4>Reply-Fields</h4>
          <b-table
            hover
            :items="historyList"
            :fields="fields"
            striped
            dark
            :fixed="true"
          ></b-table>
        </b-card-text>
      </b-card>

      <b-card
        title="compact endpoint"
        bg-variant="dark"
        class="mt-2 text-light"
        class-title
      >
        <b-card-text class="text-light">
          <h4>Description</h4>
          Get all items
          <p>
            <kbd>https://api.poe.watch/compact&league={league}</kbd>
            <br />Example URL:
            <kbd>
              <a
                href="https://api.poe.watch/compact&league=Harvest"
                target="_blank"
                >https://api.poe.watch/compact&league=Harvest</a
              >
            </kbd>
          </p>
          <h4>Reply-Fields</h4>
          <b-table
            hover
            :items="combinedList"
            :fields="fields"
            striped
            dark
            :fixed="true"
          ></b-table>
        </b-card-text>
      </b-card>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
export default {
  name: "api",

  data() {
    return {
      fields: ["Param", "Type", "Description"],
      stashID: "",
      getList: [
        {
          Param: "name",
          Type: "string",
          Description: "Name of the item",
        },
        {
          Param: "type",
          Type: "string",
          Description: "base item field",
        },
        {
          Param: "category",
          Type: "string",
          Description: "Category the item belongs to.",
        },
        {
          Param: "group",
          Type: "string",
          Description: "Secondary category some item belongs to.",
        },
        {
          Param: "frame",
          Type: "int",
          Description: "Representation of item rarity. Same as official",
        },
        {
          Param: "mapTier",
          Type: "int",
          Description: "Tier of a map",
        },
        {
          Param: "baseIsShaper",
          Type: "bool",
          Description: "Bool if the base has shaper influence",
        },
        {
          Param: "baseIsElder",
          Type: "bool",
          Description: "Bool if the base has elder influence",
        },
        {
          Param: "baseItemLevel",
          Type: "int",
          Description: "Base item level",
        },
        {
          Param: "gemLevel",
          Type: "int",
          Description: "Level of a gem in the range from 1 to 21",
        },
        {
          Param: "gemQuality",
          Type: "int",
          Description: "Quality of a gem in the range from 0 to 23",
        },
        {
          Param: "gemIsCorrupted",
          Type: "bool",
          Description: "Bool if the gem is corrupted",
        },
        {
          Param: "stackSize",
          Type: "int",
          Description: "Default stack size",
        },
        {
          Param: "icon",
          Type: "string",
          Description: "Icon of the item",
        },
      ],
      categoriesList: [
        {
          Param: "id",
          Type: "int",
          Description: "id of the given category",
        },
        {
          Param: "name",
          Type: "string",
          Description: "Name of the category for the get endpoint",
        },
        {
          Param: "display",
          Type: "string",
          Description: "Name of the category in a better format for reading.",
        },
      ],
      combinedList: [
        {
          Param: "items",
          Type: "array",
          Description:
            "contains every item in an array. Check the get endpoint for more information.",
        },
      ],
      historyList: [
        {
          Param: "mean",
          Type: "float64",
          Description: "mean value for the given day at date",
        },
        {
          Param: "date",
          Type: "float64",
          Description: "day",
        },
      ],
    };
  },
  mounted: function () {
    axios.get("https://api.poe.watch/status").then((res) => {
      if (res.status == 200) {
        let changeID = res.data.changeID;
        if (changeID != "") {
          this.stashID = changeID;
        }
      }
    });
  },
};
</script>

<style lang="scss">
.card-title {
  color: #b97575;
  background-color: blue;
}
</style